<div class="container signup-error-landing">
    <div class="signup-error-landing__logo">
        <div class="signup-landing__header__img">
            <img *ngIf="invitation && invitation.account && invitation.account.logo"
                 class="margin-bottom-20"
                 [src]="invitation.account.logo"
                 alt="Infomaniak" />
            <img *ngIf="!invitation || !invitation.account"
                 class="margin-bottom-20"
                 [src]="'/assets/images/ui/logo-infomaniak.svg'"
                 alt="Infomaniak" />
            <span *ngIf="invitation && invitation.account && !invitation.account.logo"
                  class="account-name"
                  [innerHTML]="invitation.account.organization_name | escapeHtml">
            </span>
        </div>
    </div>
    <div class="signup-error-landing__content">
        <error-already-accepted *ngIf="invitation.status === 'accepted'">
        </error-already-accepted>
        <error-expired *ngIf="invitation.status === 'expired'">
        </error-expired>
        <error-requests *ngIf="invitation.status === 'too_many_request'">
        </error-requests>
        <error-own *ngIf="invitation.status === 'user_matching_invited_by'">
        </error-own>
        <error-not-match *ngIf="invitation.status === 'user_not_matching'">
        </error-not-match>
        <error-canceled *ngIf="invitation.status === 'cancelled'">
        </error-canceled>
        <error-generic *ngIf="invitation.status === 'error'">
        </error-generic>
        <error-deleted *ngIf="invitation.status === 'deleted'">
        </error-deleted>
    </div>
</div>
